import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ImProfile } from "react-icons/im";
import { FaEye } from "react-icons/fa";
import { FcDocument } from "react-icons/fc";
import { CgProfile } from "react-icons/cg";
import { RiProfileFill } from "react-icons/ri";
import axios from 'axios';
import './profile.css';

export default function Profile() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/user/user/${userId}`);
        setUser(response.data);
      } catch (error) {
        setError('Error fetching user data');
        console.error('Error fetching user:', error);
      }
    };

    fetchUser();
  }, [userId]);

  const handleViewCV = () => {
    if (user?.cv) {
      window.open(`https://backend.ems.uk.hiradentallab.com/${user.cv}`, '_blank');
    } else {
      alert('CV not available');
    }
  };

  const handleViewDocuments = () => {
    if (user?.pastWorkCertificate) {
      window.open(`https://backend.ems.uk.hiradentallab.com/${user.pastWorkCertificate}`, '_blank');
    } else {
      alert('Documents not available');
    }
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="profile-container sidebar-closed">
      <h1 className="profile-header">
        <CgProfile /> Profile
      </h1>
      <hr />
      <h1 className="profile-subheader">
        <ImProfile /> Personal Information:
      </h1>
      <hr />

      <Container fluid className="container-profile">
        <Row className="align-items-center">
          <Col md={4} className="d-flex justify-content-center">
            <div className="profile-photo-container">
              <h5>Profile Photo</h5>
              {user.profilePhoto ? (
                <img
                  src={`https://backend.ems.uk.hiradentallab.com/${user.profilePhoto}`}
                  alt={`${user.name}'s profile`}
                  className="employee-photo"
                />
              ) : (
                <p>No profile photo available.</p>
              )}
            </div>
          </Col>
          <Col md={8}>
            <div className="mb-3">
              <h2 className="profile-info">Name: {user.name}</h2>
              <hr />
              <h4 className="profile-text">Role: {user.role}</h4>
              <hr />
              <h6 className="profile-text">Email: {user.email}</h6>
              <hr />
              <h6 className="profile-text">Phone: {user.phone}</h6>
              <hr />
              <h6 className="profile-text">
                Date of Birth: {new Date(user.birthday).toLocaleDateString()}
              </h6>
              <hr />
              <h6 className="profile-text">Gender: {user.gender}</h6>
              <hr />
              <h6 className="profile-text">Country: {user.country}</h6>
              <hr />
              <h6 className="profile-text">City: {user.city}</h6>
              <hr />
              <h6 className="profile-text">Address: {user.address}</h6>
              <hr />
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={6} className="d-flex justify-content-center mb-4 mb-md-0">
            <div className="profile-photo-container">
              <h5>ID Front</h5>
              {user.idCardFront ? (
                <img
                  src={`https://backend.ems.uk.hiradentallab.com/${user.idCardFront}`}
                  alt={`${user.name}'s ID Front`}
                  className="employee-photo"
                />
              ) : (
                <p>ID Front unavailable.</p>
              )}
            </div>
          </Col>
          <Col md={6} className="d-flex justify-content-center mb-4 mb-md-0">
            <div className="profile-photo-container">
              <h5>ID Back</h5>
              {user.idCardBack ? (
                <img
                  src={`https://backend.ems.uk.hiradentallab.com/${user.idCardBack}`}
                  alt={`${user.name}'s ID Back`}
                  className="employee-photo"
                />
              ) : (
                <p>ID Back unavailable.</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <h1 className="profile-subheader-2">
        <RiProfileFill /> Employment Information:
      </h1>
      <hr />

      <Container fluid className="container-profile">
        <Row className="align-items-start">
          <Col md={4} className="d-flex justify-content-center">
            <div className="mb-3">
              <h6>Joined Date: {new Date(user.joinDate).toLocaleDateString()}</h6>
              <hr />
              <h6 className="profile-text">Probation Period: {user.probationPeriod ? 'YES' : 'NO'}</h6>
              <hr />
              <h6 className="profile-text">Job Title: {user.jobTitle}</h6>
              <hr />
              <h6 className="profile-text">Department: {user.department.name}</h6>
              <hr />
              <h6 className="profile-text">Status: {user.status}</h6>
              <hr />
              <h6 className="profile-text">Salary: {user.salary}</h6>
              <hr />
            </div>
          </Col>

          <Col md={4} className="d-flex justify-content-center mb-4 mb-md-0">
            <Card className="profile-card">
              <Card.Body>
                <Card.Text className="text-center">
                  <FcDocument className="profile-icon icon-large" />
                  <Card.Title>CV/Resume:</Card.Title>
                </Card.Text>
                <Button className='btn btn-primary' onClick={handleViewCV}>
                  <FaEye className="profile-icon" /> View CV
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="d-flex justify-content-center mb-4 mb-md-0">
            <Card className="profile-card">
              <Card.Body>
                <Card.Text className="text-center">
                  <FcDocument className="profile-icon icon-large" />
                  <Card.Title>Documents:</Card.Title>
                </Card.Text>
                <Button className='btn btn-primary' onClick={handleViewDocuments}>
                  <FaEye className="profile-icon" /> View Documents
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
